import React, { PureComponent } from "react";

import styles from "./Social.local.scss";
import classnames from "classnames";

import _ from "i18n";

export default class SocialComponent extends PureComponent {
  render() {
    const {
      resource,
      onClickLike,
      countDislike,
      countLike,
      onClickFav,
      customStyle
    } = this.props;
    const { countComments, social } = resource;

    return (
      <ul className={classnames(styles.social, styles[customStyle])}>
        <li
          className={classnames(
            styles.socialAction,
            styles.socialLike,
            social && social.isLiked && social.isLiked === 1
              ? styles.socialActive
              : ""
          )}
          onClick={onClickLike.bind(this, true, false)}
        >
          <i className="icon icon-like" />
          <span>{countLike ? countLike : 0}</span>
        </li>
        <li
          className={classnames(
            styles.socialAction,
            styles.socialLike,
            social && social.isLiked !== undefined && social.isLiked === 0
              ? styles.socialActive
              : ""
          )}
          onClick={onClickLike.bind(this, false, false)}
        >
          <i className="icon icon-dislike" />
          <span>{countDislike ? countDislike : 0}</span>
        </li>
        <li>
          <i className="icon icon-bubble" />
          <span>{countComments ? countComments : 0}</span>
        </li>
        <li>
          <i className="icon icon-share" />
          {customStyle === "customStyle1" ? <span>{_("Share")}</span> : null}
        </li>
        <li
          onClick={onClickFav.bind(this, false)}
          className={classnames(
            styles.socialAction,
            social && social.isFavorite && social.isFavorite === 1
              ? styles.socialActive
              : ""
          )}
        >
          <i className="icon icon-star" />
          {customStyle === "customStyle1" ? <span>{_("Favoris")}</span> : null}
        </li>
      </ul>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Common/Social/SocialComponent.js